import type { ComponentType, FC } from 'react';
import { Button } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';

import { Confete } from '../../padroes/Confete';
import styles from './Sucesso.module.scss';

// A CONFIRMAÇÃO DE UM PAGAMENTO (a assinatura em /planos/sucesso, o Pass Access no desbloqueio), em
// tela cheia: o pictograma, o que aconteceu, o que isso libera e o próximo passo. Um só botão. O
// confete comemora uma vez ao abrir (e não aparece para quem reduz o movimento).

export const Sucesso: FC<{
  pictograma: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  titulo: string;
  subtitulo: string;
  texto: string;
  botao: string;
  seguir: () => void;
}> = ({ pictograma: Pictograma, titulo, subtitulo, texto, botao, seguir }) => (
  <main className={styles.tela} data-ui-carbon=''>
    <Confete />
    <div className={styles.coluna} role='status'>
      <Pictograma className={styles.pictograma} aria-hidden />
      <h1 className={styles.titulo}>{titulo}</h1>
      <p className={styles.subtitulo}>{subtitulo}</p>
      <p className={styles.texto}>{texto}</p>
      <Button kind='primary' size='lg' renderIcon={ArrowRight} onClick={seguir} className={styles.botao}>{botao}</Button>
    </div>
  </main>
);
